const isArr = (val) => typeof val === "object" && Array.isArray(val);
const isEmpty = (val) => val && val.length === 0;
const isStr = (val) => typeof val === "string";
const isNill = (val) => val === undefined || val === null;
const hasInArr = (arr, val) => arr.indexOf(val) !== -1;

export { isArr, isEmpty, isNill, hasInArr, isStr };
